import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { COUNTRY_CODES } from '../../../shared/constants';

export const CountryCodeSelectField = (props) => {
  const {
    field: {
      name, onBlur, onChange, value,
    },
    form: { setFieldTouched },
    placeholder,
  } = props;

  const selectedOption = COUNTRY_CODES.find((option) => option.value === value) || null;

  const handleBlur = () => {
    onBlur({
      target: {
        name,
      },
    });
    // Mark field as touched on blur to ensure error displays
    setFieldTouched(name, true);
  };

  return (
    <Select
      isClearable
      isSearchable
      name={name}
      onBlur={handleBlur}
      onChange={(option) => {
        onChange({
          target: {
            name,
            value: option ? option.value : '',
          },
        });
      }}
      options={COUNTRY_CODES}
      placeholder={placeholder}
      value={selectedOption}
    />
  );
};

CountryCodeSelectField.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string.isRequired,
    onBlur: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string,
  }).isRequired,
  form: PropTypes.shape({
    setFieldTouched: PropTypes.func.isRequired,
  }).isRequired,
  placeholder: PropTypes.string.isRequired,
};

export const PhoneNumberInputField = (props) => {
  const {
    field: {
      name, value, onChange, onBlur,
    },
    placeholder,
    ...rest
  } = props;

  const handleChange = (e) => {
    const inputValue = e.target.value;
    // Only allow digits and dashes, limit to 20 characters
    let filteredValue = inputValue.replace(/[^0-9-]/g, '');

    if (filteredValue.length > 20) {
      filteredValue = filteredValue.slice(0, 20);
    }

    // Create a new event-like object for Formik
    const syntheticEvent = {
      target: {
        name,
        value: filteredValue,
      },
    };

    onChange(syntheticEvent);
  };

  return (
    <input
      {...rest}
      type='tel'
      name={name}
      value={value || ''}
      onChange={handleChange}
      onBlur={onBlur}
      placeholder={placeholder}
      className='form-control'
      maxLength={20}
    />
  );
};

PhoneNumberInputField.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string.isRequired,
    onBlur: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string,
  }).isRequired,
  placeholder: PropTypes.string.isRequired,
};
